import { render, staticRenderFns } from "./StoresAdd.vue?vue&type=template&id=1f948814"
import script from "./StoresAdd.vue?vue&type=script&lang=js"
export * from "./StoresAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports